import React from 'react'
import { Chips, Dummy, MainDiv, StudentDiv, CustomDiv } from './style'
import CloseIcon from '../../../../../../components/icons/CloseIcon'

const EventCard = ({ selectedData, handleRemoveFilter }) => {
  return (
      <MainDiv>
        <StudentDiv>Event for </StudentDiv>

        {selectedData?.length > 0 ? (
          selectedData.map((degree, index) => {
            const hasDepartments = degree.streams?.length > 0
            return (
              <React.Fragment key={degree.degreeId}>
                {hasDepartments ? (
                  degree.streams.map(dep => {
                    const hasSpecializations = dep?.specializations?.length > 0
                    return (
                      <React.Fragment
                        key={`${degree.degreeId}-${dep.streamId}`}
                      >
                        {hasSpecializations ? (
                          dep.specializations.map(spec => (
                            <Chips
                              key={`${degree.degreeId}-${dep.streamId}-${spec.id}`}
                            >
                              <div>
                                {`${degree.shortForm} - ${dep.name} (${spec.name})`}
                              </div>
                              <CustomDiv
                                onClick={() =>
                                  handleRemoveFilter(
                                    degree,
                                    'specialisation',
                                    degree?.degreeId,
                                    dep?.streamId,
                                    spec?.id
                                  )
                                }
                              >
                                <CloseIcon width={15} height={15} />
                              </CustomDiv>
                            </Chips>
                          ))
                        ) : (
                          <Chips key={`${degree.degreeId}-${dep.streamId}`}>
                            <div>{`${degree.shortForm} - ${dep.name}`}</div>
                            <CustomDiv
                              onClick={() =>
                                handleRemoveFilter(
                                  degree,
                                  'stream',
                                  degree?.degreeId,
                                  dep?.streamId
                                )
                              }
                            >
                              <CloseIcon width={15} height={15} />
                            </CustomDiv>
                          </Chips>
                        )}
                      </React.Fragment>
                    )
                  })
                ) : (
                  <Chips key={degree.degreeId}>
                    <div>{degree.shortForm}</div>
                    <CustomDiv
                      onClick={() =>
                        handleRemoveFilter(
                          degree,

                          'degree',
                          degree?.degreeId
                        )
                      }
                    >
                      <CloseIcon width={15} height={15} />
                    </CustomDiv>
                  </Chips>
                )}
              </React.Fragment>
            )
          })
        ) : (
          <Dummy>Degree / department / specialisation not selected </Dummy>
        )}
      </MainDiv>
  )
}
export default EventCard
